import React, { useEffect, useMemo, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Clipboard2Data, PencilSquare } from "react-bootstrap-icons";
import EditMedicalInformationModal from "./EditMedicalInformationModal";
import { useDispatch, useSelector } from "react-redux";
import { handleFillStepData } from "../config/claimSlice";
import {
  GetAllBodySite,
  GetMissingTooth,
} from "../../preauthorization/config/preauthorizationApi";
const MedicalInformationRequest = () => {
  const dispatch = useDispatch();
  const { claimRequestData, stepFormData, viewClaimInfo } = useSelector(
    (state) => state.claim,
  );
  const { missingTeethListReason, missingTeethList } = useSelector(
    (state) => state.preauthorization,
  );
  const { allPermissionType } = useSelector((state) => state.role);
  const claimsSetting = allPermissionType?.[0]?.rolemngmt_name?.find(
    (item) =>
      item?.rolemngmttyp_name === "Claim" ||
      item?.rolemngmttyp_name === "Claims",
  );
  const [showMedicalModal, setShowMedicalModal] = useState(false);
  const claimRequest = claimRequestData?.entry?.find(
    (item) => item?.resource?.resourceType === "Claim",
  );

  useEffect(() => {
    if (missingTeethList?.length === 0) {
      dispatch(GetMissingTooth());
    }
    if (missingTeethListReason?.length === 0) {
      dispatch(GetAllBodySite());
    }
  }, []);

  const supportingInfo = claimRequest?.resource?.supportingInfo || [];
  const supInfo = useMemo(
    () => viewClaimInfo?.payload_json?.sup_info || {},
    [viewClaimInfo?.payload_json?.sup_info],
  );

  const getVitalSignValue = (targetCode) => {
    const item = supportingInfo?.find((entry) =>
      entry.category?.coding?.some((coding) => coding.code === targetCode),
    );

    return item?.code?.text || item?.valueString || null;
  };

  const missingtooth = supportingInfo?.find(
    (item) => item?.category?.coding?.[0]?.code === "missingtooth",
  );

  const status = viewClaimInfo?.claim_status;

  const isDisabled =
    status?.toLowerCase() === "invalid" ||
    status?.toLowerCase() === "valid" ||
    status?.toLowerCase() === "rejected" ||
    status?.toLowerCase() === "in process" ||
    status?.toLowerCase() === "validation error" ||
    status?.toLowerCase() === "invalid" ||
    status?.toLowerCase() === "cancelled";

  useEffect(() => {
    dispatch(
      handleFillStepData({
        check: "chief_complaint",
        value:
          getVitalSignValue("chief-complaint") ||
          supInfo["17"]?.chfcmp?.code ||
          "",
      }),
    );
    dispatch(
      handleFillStepData({
        check: "treatment_plan",
        value:
          getVitalSignValue("treatment-plan") || supInfo["20"]?.trtpln || "",
      }),
    );
    dispatch(
      handleFillStepData({
        check: "physical_examination",
        value:
          getVitalSignValue("physical-examination") ||
          supInfo["22"]?.phyexmn ||
          "",
      }),
    );
    dispatch(
      handleFillStepData({
        check: "patient_history",
        value:
          getVitalSignValue("patient-history") ||
          supInfo["21"]?.pathistry ||
          "",
      }),
    );
    dispatch(
      handleFillStepData({
        check: "history_present_illness",
        value:
          getVitalSignValue("history-of-present-illness") ||
          supInfo["23"]?.histrypreill ||
          "",
      }),
    );
    dispatch(
      handleFillStepData({
        check: "significant_sign",
        value: viewClaimInfo?.other_fields?.sgnfcntsign,
      }),
    );
    dispatch(
      handleFillStepData({
        check: "clinical_data",
        value: viewClaimInfo?.other_fields?.clncldata,
      }),
    );
    dispatch(
      handleFillStepData({
        check: "other_conditions",
        value: viewClaimInfo?.other_fields?.othrconditions,
      }),
    );
    dispatch(
      handleFillStepData({
        check: "missing_tooth",
        value:
          missingtooth?.code || (supInfo["26"]?.msngtooth?.code ? true : false),
      }),
    );
    dispatch(
      handleFillStepData({
        check: "missing_tooth_number",
        value:
          missingTeethList?.find(
            (item) =>
              item?.oral_code === missingtooth?.code?.coding?.[0]?.code ||
              item?.oral_code === supInfo["26"]?.msngtooth?.code,
          ) || null,
      }),
    );
    dispatch(
      handleFillStepData({
        check: "missing_tooth_date",
        value: missingtooth?.timingDate || supInfo["26"]?.msngtooth?.dte || "",
      }),
    );
    dispatch(
      handleFillStepData({
        check: "missing_reason",
        value:
          missingTeethListReason?.find(
            (item) =>
              item?.msngtoothcde_code ===
                missingtooth?.reason?.coding?.[0]?.code ||
              item?.msngtoothcde_code === supInfo["26"]?.msngtooth?.resncde,
          ) || null,
      }),
    );
  }, [claimRequestData, viewClaimInfo, dispatch]);

  const medicalInfo = [
    {
      title: "Chief Complaint",
      value: `${stepFormData?.chief_complaint || ""}` || "",
    },
    {
      title: "Treatment Plan",
      value: `${stepFormData?.treatment_plan || ""}`,
    },
    {
      title: "Physical Examination",
      value: `${stepFormData?.physical_examination || ""}`,
    },
    {
      title: "Patient History",
      value: `${stepFormData?.patient_history || ""}`,
    },
    {
      title: "History Of Present Illness",
      value: `${stepFormData?.history_present_illness || ""}`,
    },
  ];
  return (
    <>
      <div>
        <Card.Header className="d-flex badge-subtle-warning text-warning border-warning justify-content-between border-bottom align-items-center">
          <strong className="fs-12 fw-bold text-warning">
            <Clipboard2Data className="me-2" /> Medical Information
          </strong>
          {isDisabled && Number(claimsSetting?.submit) === 1 && (
            <PencilSquare
              onClick={() => {
                setShowMedicalModal(true);
              }}
              size={12}
              className="text-warning"
              role="button"
            />
          )}
        </Card.Header>

        <Card.Body className="p-2">
          <Row>
            {medicalInfo.map((item, index) => (
              <Col
                key={index}
                xs={12}
                sm={6}
                className="d-flex  flex-column mb-1"
              >
                <div className="text-800 fw-bold fs-12">{item.title}</div>
                <div className="fw-semibold text-600 fs-12">{item.value}</div>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </div>
      <EditMedicalInformationModal
        show={showMedicalModal}
        onHide={() => setShowMedicalModal(false)}
      />
    </>
  );
};

export default MedicalInformationRequest;
